import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CollectionsPage } from '@/domains/credit';

// El router coacciona un `?credit=1188` a número: se acepta y se normaliza a texto.
// `.catch(undefined)` descarta solo el parámetro inválido, nunca los tres.
const deepLinkParam = z
    .union([z.string(), z.number()])
    .transform(String)
    .optional()
    .catch(undefined);

const searchSchema = z.object({
    retailer: deepLinkParam,
    collector: deepLinkParam,
    credit: deepLinkParam,
});

export type CollectionsSearch = z.infer<typeof searchSchema>;

/** Deep links: `?retailer=` fija la cadena, `?collector=` filtra la lista y `?credit=` abre esa
 *  asignación. Un parámetro cosmético nunca tumba la ruta: lo que no valida se ignora. */
export function parseCollectionsSearch(search: Record<string, unknown>): CollectionsSearch {
    const parsed = searchSchema.safeParse(search);
    return parsed.success ? parsed.data : {};
}

// Ruta estática: gana sobre la dinámica hermana `$section` (que sigue cubriendo el resto).
export const Route = createFileRoute('/_backoffice/credit/collections')({
    validateSearch: parseCollectionsSearch,
    component: CreditCollections,
});

function CreditCollections() {
    const { retailer, collector, credit } = Route.useSearch();
    return <CollectionsPage retailer={retailer} collector={collector} credit={credit} />;
}
